import { Link } from "react-router-dom";
import { StoryThread } from "@app/types/Cue";
import { textToSlug } from "@util/helpers";
import cx from "classnames";

export type StoryThreadProps = {
  rootClassName?: string;
  storyThread: StoryThread;
};

export default function StoryThreadLink({
  rootClassName,
  storyThread: { value },
}: StoryThreadProps): React.ReactElement {
  return (
    <Link
      className={cx(
        "font-poppins text-4xs font-light uppercase tracking-[1px] hover:underline",
        rootClassName
      )}
      to={"/" + textToSlug(value)} // Find a way to get the story thread link, for now we will use this. (URL should start with / so that link would be https://www.businesstimes.com.sg/spotlight which is correct otherwise it is displaying as https://www.businesstimes.com.sg/companies-markets/spotlight on listing pages)
      target="_blank"
      rel="noreferrer"
      referrerPolicy="strict-origin-when-cross-origin"
      title={value}
      reloadDocument
      data-testid="story-thread-link-component"
    >
      {value}
    </Link>
  );
}
